import { useState, useCallback } from "react";
import AssetInformation from "./AssetInformation";
import { useDispatch, useSelector } from "react-redux";
import CommentBee from "../../../../../assets/images/PenndingApproval/Comment Bee.png";
import navOperations from "redux/Navigation/operations";
import { CONSTANTS } from "client/utils/constants";
import { GetStatusIcon } from "client/utils/IconsUtil";


const AssetInformationContainer = (props : any) => {
  const assetOrderByIdItem = props?.assetOrderByIdItem;
  const assetOrderByIdIndex = props?.assetOrderByIdIndex;
  const detailsByIdItem = props?.detailsByIdItem;

  const dispatch = useDispatch();
  const [resetForm, setresetForm] = useState(false);

  const resetOnclick = () => {
    setresetForm(true);
  };

  const { transferOrderByIdData, activeRow }: any = useSelector((state: any) => ({
    transferOrderByIdData: state.TransferOrderReducer.transferOrderByIdData,
    activeRow: state.CustomerMyOrder.data
  }));

  const [Popupcontent, setPopupcontent] = useState<any>({
    title: "",
    isDialogVisible: false,
    isTitleWarning: false,
    subtextcontent: "",
    primaryBtnText: "",
    outlineBtnText: "",
    isSingleConfirmationBtn: false,
    isCommentboxVisible: false,
    isCompletedReportVisible: false,
    titleImg: "",
    isCommentBoxRequire: false,
    outlineBtnnavigateTo: "",
    primaryBtnnavigateTo: "",
    actionby: "",
    value: 0,
    comments: "",
  });

  const resubmitReq = (itemDescription: any) => {
    let resubmitsubtext = (
      <>
        <p>Are you sure you want to resubmit the item</p>
        <p>
          <b>{itemDescription}</b>
        </p>
      </>
    );
    setPopupcontent({
      ...Popupcontent,
      titleImg: CommentBee,
      title: "RESUBMIT ITEM",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: resubmitsubtext,
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      isSingleConfirmationBtn: false,
      isCommentboxVisible: true,
      isCommentBoxRequire: false,
      isCompletedReportVisible: false,
      outlineBtnnavigateTo: "",
      primaryBtnnavigateTo: "Home",
      actionby: "CancelOrderBtn",
    });
  };

  const hideDialog = useCallback(
    () => setPopupcontent({ ...Popupcontent, isDialogVisible: false }),
    []
  );
  const dispatchNav = navOperations.dispatchNav(dispatch);

  const popupOutlinebtnOnclick = (item: any) => {
    if (item !== "") {
      dispatchNav(item);
    }
    hideDialog();
  };

  const [selectedAttachments, setSelectedAttachments] = useState<any>([]);
  const [isAttachmentBtnClicked, setIsAttachmentBtnClicked] = useState<any>([]);
  const [linkAttachmentId, setLinkAttachmentId] = useState();

  const onLinkAttachmentClicked = (i: any) => {
    const attachments = [...isAttachmentBtnClicked];
    attachments[i] = true;
    setIsAttachmentBtnClicked(attachments);
    setLinkAttachmentId(i);
  };

  const onLinkAttachmentClosed = (i: any) => {
    const attachments = [...isAttachmentBtnClicked];
    attachments[i] = false;
    setIsAttachmentBtnClicked(attachments);
    setLinkAttachmentId(i);
  };

  const iconReturn = (status: any) => {
    let src = GetStatusIcon(status)?.icon;
    return <img src={src} alt="statusIcon" className={getClassForIcon(status)} />;
  };

  const getClassForIcon = (status:any) => {
    const tempStatus = [CONSTANTS.ORDER_STATUS.COMPLETED,
      CONSTANTS.ITEM_STATUS.TRANSFER_COMPLETE,
      CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE,
      CONSTANTS.ITEM_STATUS.REACTIVATION_COMPLETE];
    if(tempStatus.includes(status)){
      return 'completedicon statusIcon';
    }else if(status === CONSTANTS.ITEM_STATUS.FLEET_SETUP){
      return 'fleetsetupicon statusIcon'
    }else if(status === CONSTANTS.ITEM_STATUS.SUBMITTED_TO_FINANCE){
      return 'submittedtofinanceicon statusIcon'
    }else if(status === CONSTANTS.ORDER_STATUS.FLEET_PROCESSING){
      return 'fleetprocessingicon statusIcon'; 
    }else{
      return 'statusIcons'
    }
  }

  const isValidForPenaltyFee = (selectedOption?: any) => {
    if (selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_NO_TITLE || 
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_NO_TITLE ||
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_OWNED_ASSET_TITLED || 
      selectedOption == CONSTANTS.DISPOSITION_CHOICES.WRITE_OFF_LEASED_ASSET_TITLED) {
      return true
    } else {
      return false
    }
  }

  return (
    <AssetInformation
      activeRow={activeRow}
      resetOnclick={resetOnclick}
      resetForm={resetForm}
      resubmitReq={resubmitReq}
      Popupcontent={Popupcontent}
      hideDialog={hideDialog}
      popupOutlinebtnOnclick={popupOutlinebtnOnclick}
      isAttachmentBtnClicked={isAttachmentBtnClicked}
      linkAttachmentId={linkAttachmentId}
      setIsAttachmentBtnClicked={setIsAttachmentBtnClicked}
      onLinkAttachmentClosed={onLinkAttachmentClosed}
      onLinkAttachmentClicked={onLinkAttachmentClicked}
      setSelectedAttachments={setSelectedAttachments}
      selectedAttachments={selectedAttachments}
      iconReturn={iconReturn}
      orderDetails={transferOrderByIdData}
      assetOrderByIdIndex = {assetOrderByIdIndex}
      assetOrderByIdItem = {assetOrderByIdItem}
      detailsByIdItem = {detailsByIdItem}
      isValidForPenaltyFee = {isValidForPenaltyFee}
    />
  );
};

export default AssetInformationContainer;
